// 2026-09-17：平台栏目改名与超管维护入口共用规则，避免分店改名或历史缓存放行。
export const SYSTEM_MAINTENANCE_PERMISSION = 'system.maintenance'

// 2026-09-20：系统参数设置是平台能力，按稳定键/路径拦截分店旧缓存，不扩大为超管专属。
export const isPlatformOnlyAdminFunction = (item: any): boolean => {
  const url = String(item?.functionUrl || '').trim().toLowerCase().split(/[?#]/, 1)[0].replace(/\/+$/, '')
  // 2026-09-22：平台统一功能说明配置同样禁止下放分店，独立于系统参数编辑权限。
  return ['system.settings', 'system.functionguides'].includes(String(item?.functionKey || '').trim().toLowerCase())
    || ['/system/settings', '/system/functionguides'].includes(url)
}

export const isBranchPlatformOnlyFunction = (user: any, item: any): boolean =>
  Number(user?.orgId) !== 1000 && isPlatformOnlyAdminFunction(item)

export const isPlatformSuperAdministrator = (user: any): boolean =>
  Number(user?.orgId) === 1000 && Number(user?.roleId) === 1

export const isPlatformSuperAdminPermission = (key: unknown): boolean =>
  key === 'platform.orgrights' || key === SYSTEM_MAINTENANCE_PERMISSION

export const canManageSystemMaintenance = (user: any, functions: any): boolean =>
  isPlatformSuperAdministrator(user) && Array.isArray(functions)
  && functions.some(item => item?.functionKey === SYSTEM_MAINTENANCE_PERMISSION
    && item.functionType === 'FUNC' && item.disabled !== true && Number(item.disabled || 0) === 0)

export const isRetiredPlatformMenu = (user: any, item: any): boolean =>
  Number(user?.orgId) === 1000 && (item?.functionKey === 'datainit'
    || item?.functionKey === 'platform.datainit' || item?.functionUrl === '/platform/datainit')

export const administrationTitleKey = (title: unknown, orgId: unknown): string => {
  const key = title == null ? '' : String(title)
  if (Number(orgId) !== 1000) return key
  if (key === 'branchlist') return 'platform.merchants'
  if (key === 'system.banner') return 'system.siteNotifications'
  return key
}
